import React, { useState } from 'react';

const HelpIcon = ({ help, position = 'right' }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const iconStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginLeft: '8px',
    transition: 'all 0.2s ease',
    border: '2px solid #bbdefb',
    position: 'relative',
    flexShrink: 0,
  };

  const iconHoverStyle = {
    ...iconStyle,
    backgroundColor: '#1976d2',
    color: '#fff',
    transform: 'scale(1.1)',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
  };

  // Tooltip positioning based on position prop
  const getTooltipPosition = () => {
    const baseStyle = {
      position: 'absolute',
      backgroundColor: '#333',
      color: '#fff',
      padding: '12px 16px',
      borderRadius: '8px',
      fontSize: '13px',
      fontWeight: '500',
      lineHeight: '1.5',
      zIndex: 1000,
      whiteSpace: 'normal',
      maxWidth: '280px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      animation: 'fadeInScale 0.2s ease-out',
      pointerEvents: 'none',
    };

    switch (position) {
      case 'right':
        return {
          ...baseStyle,
          left: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginLeft: '12px',
          '::before': {
            content: '""',
            position: 'absolute',
            right: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            borderWidth: '6px 6px 6px 0',
            borderStyle: 'solid',
            borderColor: 'transparent #333 transparent transparent',
          },
        };
      case 'left':
        return {
          ...baseStyle,
          right: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginRight: '12px',
          '::before': {
            content: '""',
            position: 'absolute',
            left: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            borderWidth: '6px 0 6px 6px',
            borderStyle: 'solid',
            borderColor: 'transparent transparent transparent #333',
          },
        };
      case 'top':
        return {
          ...baseStyle,
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: '12px',
          '::before': {
            content: '""',
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            borderWidth: '6px 6px 0 6px',
            borderStyle: 'solid',
            borderColor: '#333 transparent transparent transparent',
          },
        };
      case 'bottom':
      default:
        return {
          ...baseStyle,
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginTop: '12px',
          '::before': {
            content: '""',
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            borderWidth: '0 6px 6px 6px',
            borderStyle: 'solid',
            borderColor: 'transparent transparent #333 transparent',
          },
        };
    }
  };

  const tooltipStyle = getTooltipPosition();

  // For the arrow indicator, we'll use a pseudo-element workaround
  const tooltipContainerStyle = {
    position: 'relative',
  };

  if (!help) return null;

  return (
    <div
      style={tooltipContainerStyle}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div
        style={showTooltip ? iconHoverStyle : iconStyle}
        title="Click for help"
      >
        ?
      </div>

      {showTooltip && (
        <>
          <div style={tooltipStyle}>
            {help}
          </div>
          <style>{`
            @keyframes fadeInScale {
              from {
                opacity: 0;
                transform: translateY(-8px) scale(0.95);
              }
              to {
                opacity: 1;
                transform: translateY(0) scale(1);
              }
            }
          `}</style>
        </>
      )}
    </div>
  );
};

export default HelpIcon;
